
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class NbTableMenu extends Vue {
  @Prop({ type: Boolean, required: true }) readonly value!: boolean;

  @Watch("value", { immediate: true })
  isOpenChanged(val: boolean) {
    if (val) this.setElStyle();
  }

  close() {
    this.$emit("input", false);
  }

  offsetTop = 0;
  offsetRight = 0;

  get elStyle() {
    const { isMenuInverted } = this;

    if (isMenuInverted)
      return {
        top: `unset`,
        bottom: `0`,
        right: `${this.offsetRight}px`,
      };

    return {
      top: `${this.offsetTop - 24}px`,
      right: `${this.offsetRight + 24 + 8}px`,
    };
  }

  isMenuInverted = false;

  setElStyle() {
    this.$nextTick(() => {
      const { parentElement } = this.$el;

      if (!parentElement) return;

      const { top, right, height } = parentElement.getBoundingClientRect();
      const { clientWidth } = document.documentElement;

      this.offsetTop = top + height;
      this.offsetRight = clientWidth - right;

      if (!this.value) return;

      const menu = this.$el as HTMLElement;

      if (!menu) return;

      const bounds = menu.getBoundingClientRect();

      this.isMenuInverted = top + bounds.height > window.innerHeight;
    });
  }
}
